// Borg (sponsor) + landing page API services. Reads are available to any signed-in user;
// writes are admin only.
import { API_BASE_URL as BASE_URL } from '../config';

const getAuthHeaders = () => {
  const token = localStorage.getItem('auth_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

const errorFrom = async (response, fallback) => {
  try {
    const data = await response.json();
    return new Error(data.error || fallback);
  } catch {
    return new Error(fallback);
  }
};

/** All sponsors, the hoofborg first */
export const getBorge = async () => {
  const response = await fetch(`${BASE_URL}/borge`, { headers: getAuthHeaders() });
  if (!response.ok) throw await errorFrom(response, 'Kon nie borge laai nie');
  return response.json();
};

export const createBorg = async (borg) => {
  const response = await fetch(`${BASE_URL}/borge`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(borg)
  });
  if (!response.ok) throw await errorFrom(response, 'Kon nie borg skep nie');
  return response.json();
};

export const updateBorg = async (borgId, borg) => {
  const response = await fetch(`${BASE_URL}/borge/${borgId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(borg)
  });
  if (!response.ok) throw await errorFrom(response, 'Kon nie borg opdateer nie');
  return response.json();
};

export const deleteBorg = async (borgId) => {
  const response = await fetch(`${BASE_URL}/borge/${borgId}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  if (!response.ok) throw await errorFrom(response, 'Kon nie borg verwyder nie');
  return response.json();
};

/** The landing page's thank-you message */
export const getLandingBoodskap = async () => {
  const response = await fetch(`${BASE_URL}/landing`, { headers: getAuthHeaders() });
  if (!response.ok) throw await errorFrom(response, 'Kon nie die landing bladsy laai nie');
  return response.json();
};

export const setLandingBoodskap = async (boodskap) => {
  const response = await fetch(`${BASE_URL}/landing`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ boodskap })
  });
  if (!response.ok) throw await errorFrom(response, 'Kon nie die boodskap stoor nie');
  return response.json();
};
